// extracted by mini-css-extract-plugin
export default {"formBackgound":"Input_formBackgound__fOvwC","form":"Input_form__Dx3QN"};